<template>
  <div class="collapsePanel" :style="`width: ${ isCollapse ? '20px' : width };`">
    <el-card v-show="!isCollapse" class="box-card" shadow="never" @mouseleave.native="mouseleave" :style="`width: ${ width };`">
      <div slot="header">
        <div class="title">
          <slot name="title">
            <span>{{title}}</span>
          </slot>
        </div>
        <el-tooltip class="item" effect="dark" content="折叠" placement="bottom-start">
          <el-button style="float: right; padding: 3px 0;" :icon="icon" type="text" @click="showCollapse"></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="固定" placement="bottom-start">
          <el-button style="float: right; padding: 3px 0;" icon="el-icon-paperclip" type="text" @click="affix = true"></el-button>
        </el-tooltip>
      </div>
      <slot></slot>
    </el-card>
    <div class="isCollapse" v-show="isCollapse" @click="showCollapse" @mouseenter="mouseenter">
      <span style="text-align: center;">{{title.substring(0, Math.floor(title.length / 2))}}</span>
      <el-button :icon="unicon" type="text"></el-button>
      <span style="text-align: center;">{{title.substring(Math.floor(title.length / 2))}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '查询条件'
    },
    width: {
      type: String,
      default: '240px'
    },
    placement: {
      type: String,
      default: 'left'
    },
  },
  computed: {
    icon() {
      if (this.placement == 'left') {
        return 'el-icon-d-arrow-left'
      } else if (this.placement == 'right') {
        return 'el-icon-d-arrow-right'
      }
      return ''
    },
    unicon() {
      if (this.placement == 'left') {
        return 'el-icon-d-arrow-right'
      } else if (this.placement == 'right') {
        return 'el-icon-d-arrow-left'
      }
      return ''
    }
  },
  data() {
    return {
      isCollapse: false,
      affix: true
    }
  },
  methods: {
    showCollapse() {
      this.isCollapse = !this.isCollapse
    },
    mouseenter() {
      this.affix = false
      this.isCollapse = !this.isCollapse
    },
    mouseleave() {
      if (!this.affix) this.isCollapse = !this.isCollapse
    }
  }
}
</script>

<style scoped lang="less">
.collapsePanel {
  border-top: none;
  height: 100%;
  ::v-deep .el-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    flex-basis: auto;
    box-sizing: border-box;
    min-width: 0;
    .el-card__header {
      padding: 8px 20px;
      box-sizing: border-box;
      flex-shrink: 0;
      & > div,
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .title {
        flex: 1;
      }
    }

    .el-card__body {
      display: block !important;
      padding: 0;
      flex: 1;
      flex-basis: auto;
      box-sizing: border-box;
    }
  }
}
.isCollapse {
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  border: 1px #DCDFE6 solid;
  cursor: pointer;
  background-color: rgba(83, 168, 255, 0.1);
  color: #409EFF;
}
</style>